module.exports = __webpack_public_path__ + "static/media/entrevistas.71cfcf45.md";